<!-- Angular versiyon geçişinden dolayı bu ngx-shimmer-loading modülü Angular 13 versiyonunu desteklemediği için kapatıldı. -->
<!-- <div class="grid grid-nogutter">
    <p-card class="col-12">
        <ngx-shimmer-loading [shape]="'rect'" [width]="'20%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <br />
        <ngx-shimmer-loading [shape]="'rect'" [width]="'20%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <br />
        <ngx-shimmer-loading [shape]="'rect'" [width]="'20%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <br />
        <br />
        <ngx-shimmer-loading [shape]="'rect'" [width]="'400px'" [height]="'0.5rem'" [ngStyle]="{ float: 'right' }"></ngx-shimmer-loading>
        <br />
        <ngx-shimmer-loading [shape]="'rect'" [width]="'400px'" [height]="'0.5rem'" [ngStyle]="{ float: 'right' }"></ngx-shimmer-loading>
        <br />
        <ngx-shimmer-loading [shape]="'rect'" [width]="'400px'" [height]="'0.5rem'" [ngStyle]="{ float: 'right' }"></ngx-shimmer-loading>
        <br />
        <br />
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
        <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'0.5rem'"></ngx-shimmer-loading>
    </p-card>
</div> -->
